
export const AppEmptyTableBody = () => <tbody  ><tr><td> &#8203;</td></tr></tbody>